import { useState, useEffect, useCallback } from "react";
import { listNotes, createNote, updateNote, deleteNote } from "@/lib/api";
import { toast } from "sonner";

export function useNotesData() {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchNotes = useCallback(async () => {
    try {
      const res = await listNotes();
      setNotes(res.data);
    } catch {
      toast.error("Failed to load notes");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchNotes(); }, [fetchNotes]);

  const handleCreate = async (data) => {
    const res = await createNote(data);
    setNotes(prev => [res.data, ...prev]);
    return res.data;
  };

  const handleUpdate = async (noteId, data) => {
    const res = await updateNote(noteId, data);
    setNotes(prev => prev.map(n => n.note_id === noteId ? res.data : n));
    return res.data;
  };

  const handleDelete = async (noteId) => {
    await deleteNote(noteId);
    setNotes(prev => prev.filter(n => n.note_id !== noteId));
  };

  return { notes, loading, handleCreate, handleUpdate, handleDelete, refetch: fetchNotes };
}
